import { render, staticRenderFns } from "./ModalButton.vue?vue&type=template&id=df495866&"
import script from "./ModalButton.vue?vue&type=script&lang=js&"
export * from "./ModalButton.vue?vue&type=script&lang=js&"
import style0 from "./ModalButton.vue?vue&type=style&index=0&id=df495866&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports